<div *ngIf="user">
    <!-- Filter pills -->
    <div class="row mb-3">
        <div class="col">
            <div class="btn-group btn-group-toggle" role="group">
                <button type="button"
                        class="btn btn-sm"
                        [class.btn-primary]="confirmationFilterControl.value === 'all'"
                        [class.btn-outline-secondary]="confirmationFilterControl.value !== 'all'"
                        (click)="setConfirmationFilter('all')">
                    Tous ({{statusCounts.total}})
                </button>
                <button type="button"
                        class="btn btn-sm"
                        [class.btn-success]="confirmationFilterControl.value === 'true'"
                        [class.btn-outline-secondary]="confirmationFilterControl.value !== 'true'"
                        (click)="setConfirmationFilter('true')">
                    ✓ Confirmés ({{statusCounts.confirmed}})
                </button>
                <button type="button"
                        class="btn btn-sm"
                        [class.btn-warning]="confirmationFilterControl.value === 'false'"
                        [class.btn-outline-secondary]="confirmationFilterControl.value !== 'false'"
                        (click)="setConfirmationFilter('false')">
                    ○ Non confirmés ({{statusCounts.not_confirmed}})
                </button>
            </div>
        </div>
    </div>

    <!-- Search and pagination -->
    <div class="row">
        <div class="col">
            <div class="form-group form-inline">
                <input class="form-control" type="text" [formControl]="searchTermControl" placeholder="Rechercher par nom, email, code session..." />
                <small class="ml-2">
                    Total: {{itemsCount}}
                </small>
            </div>
        </div>
        <div class="col">
            <ngb-pagination (pageChange)="onPageChange($event)" [page]="page" [pageSize]="pageSize"
                [collectionSize]="itemsCount"></ngb-pagination>
        </div>
    </div>
</div>

<app-loading-overlay [active]="loading">
    <table class="table table-striped" *ngIf="user">
        <thead>
            <tr>
                <th scope="col">Date d'envoi</th>
                <th scope="col">Candidat</th>
                <th scope="col">Email</th>
                <th scope="col">Téléphone</th>
                <th scope="col">Code session</th>
                <th scope="col">Code ticket</th>
                <th scope="col">Centre d'examen</th>
                <th scope="col">Certification</th>
                <th scope="col">Date de session</th>
                <th scope="col">Confirmé</th>
                <th scope="col">Statut email</th>
                <th scope="col">Date statut</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let convocation of convocations">
                <td>
                    {{ convocation.convocationSentAt | date:'dd/MM/yyyy HH:mm' }}
                </td>
                <td>
                    <ngb-highlight [result]="convocation.firstname" [term]="searchTermControl.value"
                        style="margin-right: 5px;">
                    </ngb-highlight>
                    <ngb-highlight [result]="convocation.lastname" [term]="searchTermControl.value">
                    </ngb-highlight>
                </td>
                <td>
                    <ngb-highlight [result]="convocation.email" [term]="searchTermControl.value">
                    </ngb-highlight>
                </td>
                <td>
                    {{ convocation.phoneNumber || '-' }}
                </td>
                <td>
                    <ngb-highlight [result]="convocation.sessionCode" [term]="searchTermControl.value">
                    </ngb-highlight>
                </td>
                <td>
                    {{ convocation.voucherCode || '-' }}
                </td>
                <td>
                    {{ convocation.examCenterName || '-' }}
                </td>
                <td>
                    {{ convocation.certificationName || '-' }}
                </td>
                <td>
                    {{ convocation.sessionDate ? (convocation.sessionDate | date:'dd/MM/yyyy') : '-' }}
                </td>
                <td>
                    <span *ngIf="convocation.studentConfirmed === true" class="text-success">
                        ✓ Oui
                    </span>
                    <span *ngIf="convocation.studentConfirmed === false">
                        ○ Non
                    </span>
                </td>
                <td>
                    <span *ngIf="convocation.emailStatus === 'delivered'" class="badge badge-success"
                          title="Email délivré avec succès">
                        Délivré
                    </span>
                    <span *ngIf="convocation.emailStatus === 'opened'" class="badge badge-info"
                          title="Email ouvert par le candidat">
                        Ouvert
                    </span>
                    <span *ngIf="convocation.emailStatus === 'clicked'" class="badge badge-info"
                          title="Le candidat a cliqué sur un lien dans l'email">
                        Cliqué
                    </span>
                    <span *ngIf="convocation.emailStatus === 'sent'" class="badge badge-secondary"
                          title="Envoyé, en attente de confirmation">
                        Envoyé
                    </span>
                    <span *ngIf="convocation.emailStatus === 'hard_bounce'" class="badge badge-danger"
                          title="Adresse email invalide — contacter le candidat autrement">
                        Erreur
                    </span>
                    <span *ngIf="convocation.emailStatus === 'soft_bounce'" class="badge badge-warning"
                          title="Erreur temporaire (boîte pleine) — Brevo réessaie automatiquement">
                        Temporaire
                    </span>
                    <span *ngIf="convocation.emailStatus === 'blocked'" class="badge badge-danger"
                          title="Email bloqué par le serveur — contacter le candidat">
                        Bloqué
                    </span>
                    <span *ngIf="convocation.emailStatus === 'error'" class="badge badge-danger"
                          title="Erreur technique à l'envoi">
                        Erreur
                    </span>
                    <span *ngIf="!convocation.emailStatus"
                          title="Pas de suivi disponible">
                        -
                    </span>
                </td>
                <td>
                    {{ convocation.emailStatusChangedAt ? (convocation.emailStatusChangedAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                </td>
            </tr>
        </tbody>
    </table>

    <div *ngIf="convocations && convocations.length === 0" class="alert alert-info">
        Aucune convocation trouvée.
    </div>
</app-loading-overlay>
